import { useState } from 'react';

const PASSWORD = 'Chute2075a!';

export default function PasswordGate({ onUnlock }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = () => {
    if (value === PASSWORD) {
      sessionStorage.setItem('unlocked', 'true');
      onUnlock();
    } else {
      setError(true);
      setShake(true);
      setTimeout(() => setShake(false), 600);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') handleSubmit();
    if (error) setError(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F7F5F0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '"DM Sans", system-ui, sans-serif',
      padding: '2rem',
    }}>
      <div style={{ textAlign: 'center', maxWidth: '380px', width: '100%' }}>
        <p style={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: '1.75rem',
          fontWeight: 400,
          color: '#1A1814',
          marginBottom: '0.5rem',
          letterSpacing: '-0.01em',
        }}>Simone Ehrlich</p>
        <p style={{
          fontSize: '0.8rem',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: '#9A9590',
          marginBottom: '3rem',
        }}>Product Leader</p>
        <div style={{ animation: shake ? 'shake 0.5s ease' : 'none' }}>
          <input
            type="password"
            placeholder="Enter passphrase"
            value={value}
            onChange={e => { setValue(e.target.value); setError(false); }}
            onKeyDown={handleKey}
            autoFocus
            style={{
              width: '100%',
              padding: '0.875rem 1rem',
              border: `1px solid ${error ? '#C4622D' : '#E2DED8'}`,
              background: 'transparent',
              fontFamily: '"DM Sans", system-ui, sans-serif',
              fontSize: '0.95rem',
              color: '#1A1814',
              outline: 'none',
              marginBottom: '0.75rem',
              transition: 'border-color 0.2s',
            }}
          />
          {error && (
            <p style={{ color: '#C4622D', fontSize: '0.8rem', marginBottom: '0.75rem', textAlign: 'left' }}>
              Incorrect passphrase. Please try again.
            </p>
          )}
          <button
            onClick={handleSubmit}
            style={{
              width: '100%',
              padding: '0.875rem',
              background: '#1A1814',
              color: '#F7F5F0',
              border: 'none',
              fontFamily: '"DM Sans", system-ui, sans-serif',
              fontSize: '0.75rem',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >Enter</button>
        </div>
      </div>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400&family=DM+Sans:wght@300;400&display=swap');
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-5px); }
          80% { transform: translateX(5px); }
        }
      `}</style>
    </div>
  );
}
